export const locale = {
    lang: 'zh1',
    data: {
      'ALERTS':{
        'OK':'好'
      },
      'SHEDULE': {
        'TITLE1':	'登記開始日期',
        'TITLE2':	'輸入提醒',
        'TITLE3':	'註冊完結日期',
        'ERR01':'提醒不可少於發布日',
        'ERR02':'提醒不能大於結束日',
        'ERR03':'提醒必須在調查過程中進行',
        'ERR04':'您只能有3條提醒',
        'ERR05':'日期不能低於現在',
        'ERR06':'您今天已經發送了一封電子郵件',
        'SUC01':'提醒保存',
        'SELECT_DATE':	'選擇一個日期',
        'SAVE':	'儲存',
        'RECORDATORIOS':	'提醒電郵',
        'RECORDATORIO' :	'溫馨提示',
        'ERRORDATE':'日期不能小於當前日期',
        'SAMEDATE':'選擇當前日期作為調查的開始日期是不允許的',

        'LESSDAYS_T':'您確定要繼續嗎？',
        'LESSDAYS_I':'您需要將調查的發布日期安排在發布前至少15天，以便協作者獲得完整的溝通計劃。',
        'CONFLDATE_T':'警告！',
        'CONFLDATE_I':'如果繼續，則無法還原調查啟動日期編程。',
        'WARNING_FECHA_UPDATE':'您無法選擇今天的日期或之前的日期',
        'FECHA_UPDATE_WARNING':'請務必更改結束日期',
        'FECHA_UPDATE':'截止日期已正確更新',

        'FECHA':	'日期',
        'AGREGAR':	'新增',
        'EDITAR':	'編輯',
        'COMPLETAR_PASO':	'完成此步驟',
        'PASO_COMPLETADO':	'此步驟已完成',
        'SUBIRLOGO': '要創建調查，您需要上傳公司徽標',
        'ACEPTARREQUERIMIENTOS': '要創建調查，必須接受技術要求',
        'LOGOSSURVEY': '要創建您的調查，有必要首先建立必要的標誌',
        'SELECCIONE_FECHA': '請選擇一個日期 ',
        'DATE_REGISTERED': '啟動日期已成功註冊',
        'CLOSE_REGISTERED': '截止日期已成功註冊',
        'CLOSE_MSJ1': '截止日期必須大於發布日期',
        'CLOSE_MSJ2': '註冊關閉之前，您必須註冊發布日期',
        'REMIDEROK': '提醒已正確註冊',
        'REMIDERUPDAOK': '提醒已成功更新',
        'AVIUPDAOK': '正確更新通知',
        'REMIDER_MSJ1': '提醒必須大於發布日期',
        'REMIDER_MSJ2': '在註冊提醒之前，您必須註冊發布日期',

        'ENCUESTA': '調查表',
        'CREANDO_ENCUESTA': '創建調查...',
        'AGREGANDO_USUARIOS': '添加用戶...',
        'AGREGANDO_SECCION1': '將NPS添加到調查中...',
        'AGREGANDO_SECCION2': '在調查中添加報表...',
        'AGREGANDO_SECCION3': '為調查增加控制...',
        'AGREGANDO_SECCION4': '將人口統計信息添加到調查中...',
        'AGREGANDO_SECCION5': '在調查中添加其他內容...',
        'AGREGANDO_SECCION6': '在調查中添加全民實踐...',
        'AGREGANDO_SECCION7': '將 公开问题 添加到調查中...',
        'REINTENTAR': '重試',
        'ERROR_ENCUESTA': '創建調查時出錯',
        'ERROR_USUARIOS': '添加用戶時出錯...',
        'ERROR_SECCION1': '將NPS添加到調查時出錯...',
        'ERROR_SECCION2': '向調查中添加語句時出錯...',
        'ERROR_SECCION3': '將控件添加到調查時出錯...',
        'ERROR_SECCION4': '將受眾特徵添加到調查中時出錯...',
        'ERROR_SECCION5': '在調查中添加其他內容時出錯...',
        'ERROR_SECCION6': '將“所有實務”添加到調查中時出錯...',
        'ERROR_SECCION7': '將 公开问题 添加到調查時出錯...',
        'SUCCESS_ENCUESTA': '調查成功創建!',
        'SUCCESS_USUARIOS': '用戶添加成功!',
        'SUCCESS_SECCION1': 'NPS已成功添加到調查中！',
        'SUCCESS_SECCION2': '報表已成功添加到調查中！',
        'SUCCESS_SECCION3': '控制問題已成功添加到調查中！',
        'SUCCESS_SECCION4': '受眾特徵已成功添加到調查中！',
        'SUCCESS_SECCION5': '附加功能已成功添加到調查中！',
        'SUCCESS_SECCION6': '將所有實踐成功添加到調查中！',
        'SUCCESS_SECCION7': '公开问题 已成功添加到調查中!',
        'BTN_CREARENCUESTA': '創建調查',
        'CONTINUE_FINISH': '调查创建成功，您可以完成此步骤。',
        'LAUNCH_SURVEY': '请创建调查以完成此步骤',
        'PULSE':{
          //Shedule survey
          'MES1': ' Pulse Check月 1',
          'MES2': ' Pulse Check月 2',
          'MES3': ' Pulse Check月 3',
          'MES4': ' Pulse Check月 4',
          'MES5': ' Pulse Check月 5',
          'MES6': ' Pulse Check月 6',
          'MES7': ' Pulse Check月 7',
          'MES8': ' Pulse Check月 8',
          'MES9': ' Pulse Check月 9',
          'MES10': ' Pulse Check月 10',
          'MES11': ' Pulse Check月 11',
          'MES12': ' Pulse Check月 12',
          'EDITAR': '加',
          'INDICA': '選擇脈搏檢查日期',
          'INDICA_GENERA':'生成調查',
          'SUBINDICA_GENERA':'單擊以生成調查',

        },

      },
      'SHEDULE2_0': {
        'CARDS': {
          'PASO1': {
            'TITULO': '先決條件',
            'INFO_PRE': '創建調查之前，您需要先滿足這些先決條件',
            'INFO_POST': '您已經滿足創建調查的前提條件',
            'REQTEC': '技術要求',
            'REQTEC_TOOLTIP': '轉到技術要求',
            'LOGO': '公司標誌',
            'LOGO_TOOLTIP': '單擊以加載徽標'
          },
          'PASO2': {
            'TITULO': '發布日期',
            'TITULO_CIERRE': '截止日期',
            'INFO_PRE': '選擇並記錄調查的啟動日期',
            'INFO_POST': '選定日期',
            'INFO_POST_CIERRE': '截止日期',
            'PICKDATE': '打開日曆',
            'CHANGE': '改變日期',
            'LIS-PRORRO':'擴展名',
          },
          'PASO2_B': {
            'TITULO': '日期選擇',
            'INFO_PRE': '選擇並註冊可用於配置調查的不同日期',
            'PICKDATE': '選擇日期',
            'INFO_PROR': '擴展已分配給該產品',
            'PRORROGAS': '查看擴展',
            'TIUTLOLISTA': '創建擴展',
            'NOPROR': '您沒有分配的擴展'
          },
          'PASO3': {
            'TITULO': '提醒事項',
            'INFO_PRE': '添加提醒提交日期以回答調查',
            'INFO_POST': '您有兩個選擇：',
            'NUEVO': '註冊新提醒',
            'LISTA': '記錄的提醒',
            'LISTA_AVI': '調查前溝通',
            'TITU_AVIS':'廣告',
            'TIUTLOLISTA': '提醒已創建',
            'NORECOS': '您尚未保存任何提醒',
            'NOAVI': '您還沒有保存任何警告',
            'INFOHORA': '注意：每個提醒都顯示在研究所的本地時間：',
            'INFOHORAAVISO': '注意：每條公告均以研究所當地時間顯示：',
             'TITULOLISTA': '通知已創建',
          },
          'PASO4': {
            'TITULO': '通訊訊息',
            'INFO_PRE': '查看調查生命週期中要發送的通信消息',
            'VERMENSAJES': '查看通訊訊息'
          },
          'PASO5': {
            'TITULO': '調查檢查',
            'TITULO_ALT': '主表檢查',
            'INFO_PRE': '查看調查的各個部分，以及每個部分中添加的問題數',
            'VERMENSAJES': '查看部分數據',
            'FILTRAR': '按名稱過濾部分',
            'TABLE':{
              'SECTION': '部分',
              'VALUE': '值',
            }
          },
          'PASO6': {
            'TITULO': '調查生成歷史',
            'INFO_PRE': '上次調查生成日期:',
            'INFO_PRE_2': '產生歷史:',
          },
          'PASO7': {
            'TITULO': '調查特點',
            'INFO_PRE': '在配置調查功能之前，您需要先完成先決條件',
            'INFO_POST_1': '在創建調查之前，有必要配置調查的特徵',
            'INFO_POST_2': '您已經設置了創建調查所需的設置',
            'EMPRESA': '公司標誌',
            'CERTIFICADO': '證書標誌',
            'CARACTERISTICAS': '調查特點',
            'PREVIEW': '預習',
            'CAMBIAR': '更改圖像',
            'LOGO_EMP_INFO': '圖像以其保存的分辨率顯示，200x200 像素'
          },
          'MODALGEN': {
            'REGRESAR': '回去',
            'HISTORIAL': {
              'BOTON': '調查生成歷史',
              'TITULO': '調查生成歷史',
              'CARGANDO': '加載生成歷史',
              'ULTIMA': '上一代日期',
              'ANTERIORES': '上一代日期',
              'NOHISTO': '沒有調查的生成歷史'
            },
            'CERTIFICADO': {
              'TITULO': '證書預覽'
            },
            'URL_QR': {
              'BOTON': '獲取二維碼鏈接',
              'TITULO': '二維碼中的調查鏈接',
              'SUBTITULO': '通過掃描此二維碼，您可以直接訪問調查，而無需手動輸入鏈接',
              'DESCARGA': '要下載二維碼，請右鍵單擊圖像，然後單擊 <b> <em> 將圖像另存為 ... </em> </b> 選項',
              'REGENERARQR': 'URL 已正確修改，如果您有上一個 URL 的二維碼，則需要使用更新後的鏈接獲取新的二維碼'
            }
          },
          'STATUS': {
            'PENDING': '尚未完成',
            'OK': '準備',
            'OPT': '此步驟是可選的'
          },
          'FECHAS': {
            'TITULO': '日期選擇',
            'FECHA': '選定日期：',
            'NOTYET': '尚未選擇',
            'INFO': {
              '1': '選擇每個可用日期以配置調查。',
              '2': '注意：在每個日期選擇的時間設置為研究所的當地時間：'
            },
            'TABLA': {
              'TIPO': '日期類型',
              'FECHA': '選定日期',
              'ACCIONES': '動作'
            },
            'TIPOS': {
              'lanzamiento': '發射日期',
              'aviso1': '發布前（調查啟動前的第一個通知）',
              'aviso2': '啟動前（啟動調查前的第二次通知）',
              'cierre': '最後期限',
              'recor30': '預發布（調查前 30 天通知）',
               'registro29': '預發布（調查前 29 天通知）',
               'recor15': '預發布（調查前 15 天通知）',
               'recor7': '預發布（調查前 7 天通知）',
               'result': '結果：',
            },
            'BOTONES': {
              'ELEGIR': '選擇日期',
              'CAMBIAR': '改變日期',
              'CANCELAR': '取消',
              'ACEPTAR': '接受',
              'ENVIOCIERRE': '發送通知'
            }
          }
        },
        'CREAR': '創建調查',
        'RECREAR': '重新創建調查',
        'ENCUESTACREADA': '調查已創建',
        'ENCUESTAERROR': '調查未正確創建',
        'VERSECCIONES': '查看添加的部分',
        'BACK': '背部',
        'CERRAR': '關',
        'CREANDO': '正在創建調查，請等待，直到正確添加了每個組件',
        'RETRY': '重試該過程',
        'SECCIONES': {
          'DETALLES': '保存最後的詳細信息',
          'COMPLETA': '調查已成功創建！',
          'ENCUESTA': {
            'TITULO': '調查',
            'PROCESO': '創建調查',
            'ERROR': '創建調查時發生錯誤，請重試該過程'
          },
          'USUARIOS': {
            'TITULO': '用戶數',
            'PROCESO': '將用戶添加到調查中',
            'ERROR': '添加用戶時發生錯誤，請重試該過程',
          },
          'NPS': {
            'TITULO': 'NPS',
            'PROCESO': '將NPS添加到調查中',
            'ERROR': '添加NPS時發生錯誤，請重試此過程',
          },
          'REACTIVOS': {
            'TITULO': '陳述',
            'PROCESO': '在調查中添加報表',
            'ERROR': '添加語句時發生錯誤，請重試該過程',
          },
          'CONTROL': {
            'TITULO': '控制問題',
            'PROCESO': '向調查中添加控制問題',
            'ERROR': '添加控制問題時發生錯誤，請重試該過程',
          },
          'DEMOGRAFICOS': {
            'TITULO': '客層',
            'PROCESO': '將人口統計信息添加到調查中',
            'ERROR': '添加受眾特徵時發生錯誤，請重試此過程',
          },
          'ABIERTAS': {
            'TITULO': '公開問題',
            'PROCESO': '向調查中添加未解決的問題',
            'ERROR': '添加未解決的問題時發生錯誤，請重試此過程',
          },
          'FORALL': {
            'TITULO': '對所有人',
            'PROCESO': '將ForAll做法添加到調查中',
            'ERROR': '添加ForAll練習時發生錯誤，請重試該過程',
          },
          'ADICIONALES': {
            'TITULO': '額外',
            'PROCESO': '向調查中添加其他問題',
            'ERROR': '添加其他問題時發生錯誤，請重試該過程',
          },
          'ADICIONALES-FOCUS': {
            'TITULO': '個性化',
            'PROCESO': '向調查中添加自定義問題',
            'ERROR': '添加自定義問題時發生錯誤，請重試該過程',
          },
        },
        'MODALES': {
          'ENCUESTA': {
            'CREAR_1': '您要使用當前配置創建調查嗎？',
            'CREAR_2': '創建調查後，您將無法修改通訊消息',
            'CREAR_3': '您要開始創建調查嗎',
            'SINFECHA': '要創建調查，必須首先選擇該調查的啟動日期',
            'CREADA_1': '調查已成功創建！',
            'CREADA_2': '現在，您可以完成本節並繼續下一個',
            'RECOEXIS': '所選日期已經有註冊提醒',
            'RECOBEFORE': '您必須先選擇調查的開始日期才能記錄提醒',
            'RECOMAX': '您已經設置了所有允許的提醒，無法再註冊新的提醒',
            'LASTRECO_1': '警告：',
            'LASTRECO_2': '您已經安排了所有允許的提醒，因此您將無法再註冊新的提醒',
            'LISTARECOBEF': '您必須先選擇調查的開始日期才能查看提醒列表',
            'FINAL': '現在，您可以完成本節並繼續下一個',
            'SAVELAUNCHDATE': '正在保存調查的啟動日期，請稍候',
            'SAVEAVISODATE': '保存通知日期，請稍等',
            'AVISOOK': '通知日期已成功保存',
            'CHANGELAUNCH': '警告：如果您更改調查的開始日期，其餘日期將被刪除，您將不得不再次選擇它們，是否要選擇另一個開始日期？',
            'CHANGECLOSENOT': '通知發送狀態已成功更改',
            'GUARDANDO_LOGO': '正在保存圖片，請稍等',
            'CARGA_CERT': '要在最終文檔中獲得最高質量，請務必上傳最小分辨率為 400 x 240 像素的圖像。',
            'BORRA_RECO_1': '您確定要刪除以下日期的提醒嗎？',
            'BORRA_RECO_2': '已成功刪除提醒',
            'BORRA_AVI_1': '您確定要刪除以下日期的提醒嗎？',
            'BORRA_AVI_2': '提醒已成功提醒',
            'UPDA_AVISO':'更新提醒日期',
            'UPDA_RECOR':'更新提醒日期',
            'DELE_AVISO':'刪除提醒日期',
            'DELE_RECOR':'刪除提醒日期',
            'GUARD_RECOR':'保存提醒日期',
            'TITL_MOD_QUES_ALEAT':'要創建調查，必須啟用隨機問題驗證。',
            'TEXT_MOD_QUES_ALEAT_1':'然後執行以下步驟：',
            'TEXT_MOD_QUES_ALEAT_2':'1.- 輸入編輯調查特徵。',
            'TEXT_MOD_QUES_ALEAT_3':'2.-點擊附加配置並啟用隨機問題驗證',
          }
        },
        'CORREOS': {
          'VER': '查看訊息',
          'TIPO1': {
              'TITULO': '發布前消息',
              'INFO': '這些是在調查啟動前幾天發送的消息',
              'TIPO_1': '第一條通知消息',
              'TIPO_2': '第二條通知消息',
          },
          'TIPO2': {
              'TITULO': '邀請訊息',
              'INFO': '這是在調查啟動之日發送給協作者的消息'
          },
          'TIPO3': {
              'TITULO': '提醒訊息',
              'INFO': '這是為此目的在預定日期發送的提醒消息。'
          },
          'TIPO4': {
              'TITULO': '第一條通知消息',
              'INFO': ''
          },
          'TIPO5': {
              'TITULO': '第二條通知消息',
              'INFO': ''
          },
          'TIPO6': {
              'TITULO': '調查結束訊息',
              'INFO': '這是在調查結束日期發送給協作者的消息\n注意：僅在激活後才發送'
          },
          'TIPO7': {
            'TITULO': '給尚未開始調查的合作者的信息',
            'INFO': '這是發送給尚未開始調查的合作者的提醒消息'
          },
          'TIPO8': {
            'TITULO': '給尚未完成的合作者的消息',
            'INFO': '這是向已開始調查但尚未完成調查的參與者發送的提醒消息'
          },
        },
        'EDITOR': {
          'BOTONES': {
            'INFO': '重要信息',
            'SAVE': '保存更改',
            'EDIT': '編輯訊息',
          },
          'PENDING': '驗證過程中',
          'MODALINFO': {
            'TITULO': '有關電子郵件內容的重要信息',
            'PARTE_1': '為了使電子郵件被認為是正確的，可以在郵件正文中包含以下標籤（注意，必須至少包含一次強制標籤）：',
            'PARTE_2': '其原因是由於以下事實：當每封電子郵件的傳遞日期到達時，平台會在消息中自動執行以下替換：',
            'tag_company': '公司名稱',
            'tag_link': '訪問調查的鏈接',
            'tag_date': '調查的開始日期',
            'tag_user': '調查訪問密碼',
            'tag_dtb': '距調查啟動的天數（從發送消息的日期開始）',
            'tag_dtc': '直到調查結束的天數（從發送消息的日期開始）',
            'tag_end': '調查的截止日期',
            'tag_userAction': '用戶登錄',
            'tag_pass': '用戶密碼',
            'tag_linkAction': '文化圍棋的訪問鏈接',
            'PARTE_3': '標籤可以放置在電子郵件正文中的任何位置。一旦標籤出現在內容中，就可以保存',
            'PARTE_4': '注意：消息可能需要由項目經理進行驗證，在這種情況下，您將能夠在此屏幕上看到新電子郵件的驗證狀態。 在驗證過程中，您將無法製作新版本的電子郵件。 否則，該電子郵件將立即被視為有效，並且您可以根據需要再次對其進行編輯。',
            'OPC': '（可選）',
            'MDT': '（必填項，關閉消息中除外）'
          },
          'MODALES': {
            'SINCAMBIOS': '您尚未更改電子郵件的內容',
            'SINTAG': '無法保存郵件，找不到下一個標籤：',
            'GUARDAR_1': '您要保存對消息所做的更改嗎？',
            'GUARDAR_2': '我們提醒您，它將被發送以進行驗證，直到驗證過程結束，您將無法對其進行重新編輯。',
            'SAVEOK_1': '電子郵件內容已正確保存',
            'SAVEOK_2': '等待項目經理確認修改',
            'ENABLED': '項目經理已重新激活電子郵件編輯，您可以繼續進行修改',
            'CAMBIOIDIOMA_1': '警告：如果您要選擇其他語言，則必須先保存當前對當前語言所做的更改',
            'CAMBIOIDIOMA_2': '您要保存更改並選擇另一種語言嗎？',
          }
        },
        'ZONAS': {
          '1': '墨西哥城',
          '2': '聖薩爾瓦多',
          '3': '香港',
          '4': '新加坡',
          '5': '伊斯坦堡',
          '6': '馬尼拉',
          '11': '巴西利亞',
          '15': '馬德里',
          '18': '墨西哥城',
        },
        'SECCIONES_ESPECIALES': {
          'TITULO': '本次調查有專門的部分',
          'SUBTITULO': '以下是分組的演示用戶，每個組旨在單獨測試帶有每個特殊部分的調查，或者沒有特殊部分的調查',
          'ELEGIR': '從左側菜單中選擇一個組',
          'LISTA': {
            'TITULO': '特殊部分',
            'SIN_SECCION': '無特殊部分的調查'
          }
        },
        'CORREOS_NORM':{
          'TIPO1':{
            'TITULO': '發布前消息',
            'INFO': '這些是在調查啟動前幾天發送的消息',
          },
          'TIPO2':{
            'TITULO': '警告信息：邀請發布前 30 天' ,
            'INFO': '這些是調查啟動前幾天發送的消息'
          },
          'TIPO3':{
            'TITULO': '警告信息：邀請發布前 29 天',
            'INFO': '這些是調查啟動前幾天發送的消息'
          },
          'TIPO4':{
            'TITULO': '警告信息：邀請發布前 15 天',
            'INFO': '這些是調查啟動前幾天發送的消息'
          },
          'TIPO5':{
            'TITULO': '警告信息：邀請發布前 7 天',
            'INFO': '這些是調查啟動前幾天發送的消息'
          },
          'TIPO6': {
              'TITULO': '調查結束訊息',
              'INFO': '這是在調查結束日期發送給協作者的消息\n注意：僅在激活後才發送'
          },
          'TIPO7':{
            'TITULO': '提醒訊息',
            'INFO': '這是為此目的在預定日期發送的提醒消息。'
          },
        }
      }
    }
};
// tradicional
